import PropTypes from "prop-types";
import styled from "styled-components";
import { AccrualDetails } from "./AccrualDetails";
import { LumpDetails } from "./LumpDetails";

const Indented = styled.div`
  padding-left: 10px;
  margin-bottom: 16px;
`;
const NoMargin = styled.p`
  margin-top: 0 !important;
`;

export const RuleDetails = ({ rule }) => {
  let details;
  switch (rule.depositPolicy) {
    case "accrual":
      details = <AccrualDetails rule={rule} />;
      break;
    case "annual":
    case "anniversary":
      details = <LumpDetails rule={rule} />;
      break;
    default:
      break;
  }

  return (
    <Indented>
      {details}
      {rule.code === "unified" && (
        <NoMargin>
          Sick, vacation, compassionate leave, and other PTO types are sourced
          from this time off bank.
        </NoMargin>
      )}
      {rule.code === "personal" && (
        <NoMargin>
          Vacation, compassionate leave, and other PTO types are sourced from
          this time off bank.
        </NoMargin>
      )}
    </Indented>
  );
};

RuleDetails.propTypes = {
  rule: PropTypes.shape({
    code: PropTypes.string,
    depositPolicy: PropTypes.string,
  }).isRequired,
};
